import Room from '@/components/Room';
import { RoomDTO } from '@/dto/responseDto/floor';
import { ROLE } from '@/router/role';
import roomService from '@/services/room.service';
import { convertLetterToNumber } from '@/util/convertLetterToNumber';
import { keyTabChangeFocusByID } from '@/util/keyDown';
import { Button, Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { SelectRoom } from '..';
import './style.scss';

interface IProps {
    selectedRoom: SelectRoom[];
    data?: any;
    onSelectRoom: (value: SelectRoom) => void;
    removeSelectRoom: (value: string) => void;
    removeAllSelectRoom: () => void;
    refetch?: any;
}

const MainContent: React.FC<IProps> = ({
    selectedRoom,
    data,
    onSelectRoom,
    removeSelectRoom,
    removeAllSelectRoom,
    refetch,
}) => {
    const [elementFocusIDs, setElementFocusIDs] = useState<string[] | []>([]);
    // const queryClient = useQueryClient();

    // const info = useQuery('info', roomService.getInfo);

    const dataTable: any[] = [
        [null, null, null, null, null, null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null, null, null, null, null, null],
        [null, null, null, null, null, null, null, null, null, null, null, null],
    ];
    data?.forEach((room: any) => {
        const positionY = convertLetterToNumber(room?.floorPosition?.split('-')[0]) - 1;
        const positionX = Number(room?.floorPosition?.split('-')[1]) - 1;

        dataTable[positionX][positionY] = room;
    });

    useEffect(() => {
        if (!data?.length) return;

        let IDs: string[] = [];
        data.map((room: any) => (IDs = [...IDs, room?._id]));

        setElementFocusIDs([...IDs]);
    }, [data]);

    useEffect(() => {
        onkeydown = (event: KeyboardEvent) => {
            if (!elementFocusIDs?.length && event.keyCode === 9) {
                event.preventDefault();
                return;
            }

            keyTabChangeFocusByID({ event, elements: elementFocusIDs });
        };
    }, [elementFocusIDs]);

    return (
        <div className="list_room_wrap">
            <div className="p-main-content list-room">
                {dataTable.map((row: RoomDTO[], keyRow: number) => (
                    <div className="row" key={keyRow}>
                        {row.map((room: RoomDTO, keyRoom: number) => (
                            <Room
                                key={`${keyRow}_${keyRoom}`}
                                data={room}
                                selectedRoom={selectedRoom}
                                onSelectRoom={onSelectRoom}
                                removeSelectRoom={removeSelectRoom}
                                refetch={refetch}
                            ></Room>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MainContent;
